<template>
    <b-modal
        v-model="modalOpen"
        centered
        scrollable
        size="lg"
        style="width: 100px"
        @hide="onClose"
        @ok="onConfirm"
        title="Execution input parameters"
        header-class="header-nipige-class"
    >
        <template v-if="!workflow.name"> Loading...</template>
        <template v-else>
            <div v-for="d in inputList">
                <b-input-group class="mb-2">
                    <b-form-input
                        :aria-label="d"
                        v-model="input[d]"
                        :placeholder="d"
                    />
                </b-input-group>
            </div>
        </template>
    </b-modal>
</template>
<script>
import gql from "graphql-tag";

export default {
    name: "execute",
    data() {
        return {
            modalOpen: false,
            workflow: {},
            input: {},
        };
    },
    props: {
        open: {
            type: Boolean,
            default: false,
        },
        name: {
            type: String,
            default: null,
        },
        version: {
            type: Number,
            default: null,
        },
    },
    mounted() {
        this.modalOpen = this.open;
    },
    computed: {
        inputList() {
            const inputCaptureRegex = /workflow\.input\.([a-zA-Z0-9-_]+)\}/gim;
            const workflowStr = JSON.stringify(this.workflow);
            let match = inputCaptureRegex.exec(workflowStr);
            const inputsArray = [];
            while (match != null) {
                inputsArray.push(match[1]);
                match = inputCaptureRegex.exec(workflowStr);
            }
            return [...new Set(inputsArray)];
        },
    },
    methods: {
        onClose() {
            this.$emit("close");
        },
        onConfirm() {
            const processedInput = {};
            for (const key in this.input) {
                if (this.isJson(this.input[key])) {
                    processedInput[key] = JSON.parse(this.input[key]);
                } else {
                    processedInput[key] = this.input[key];
                }
            }

            this.$apollo
                .mutate({
                    mutation: gql`
                        mutation startWorkflow(
                            $startWorkflowRequestInput: StartWorkflowRequestInput!
                        ) {
                            executeWorkflow(
                                requestInput: $startWorkflowRequestInput
                            )
                        }
                    `,
                    variables: {
                        startWorkflowRequestInput: {
                            name: this.name,
                            version: this.version,
                            input: processedInput,
                        },
                    },
                })
                .then(({ data }) => {
                    this.$toasted.success("Workflow execution started", {
                      action: {
                        text: "Execution",
                        onClick: () => {
                          this.$router.push(
                            '/setup/workflows/history/' +
                            data.executeWorkflow
                          )
                        }
                      }
                    });
                })
                .catch((error) => {
                    console.log("execution error");
                    console.log(error);
                    this.$toasted.success("Failed to execute workflow");
                })
                .finally(() => {
                    this.$emit("close");
                });
        },
        isJson(data) {
            try {
                JSON.parse(data);
            } catch (e) {
                return false;
            }
            return true;
        },
    },
    apollo: {
        workflow: {
            query: gql`
                query getWorkflow(
                    $name: String!
                    $version: Int!
                    $skip: Boolean!
                ) {
                    getWorkflow(name: $name, version: $version)
                        @skip(if: $skip) {
                        ...partialWorkflowDef
                        startHandlers {
                            name
                            active
                            event
                            condition
                            actions {
                                action
                                completeTask {
                                    output
                                    workflowId
                                    taskRefName
                                }
                                failTask {
                                    output
                                    workflowId
                                    taskRefName
                                }
                                startWorkflow {
                                    name
                                    version
                                    input
                                }
                                expandInlineJSON
                            }
                        }
                        tasks {
                            ...workflowTask
                            forkTasks {
                                ...workflowTask
                            }
                            defaultCase {
                                ...workflowTask
                            }
                        }
                    }
                }

                fragment partialWorkflowDef on WorkflowDef {
                    name
                    version
                    historyId
                    description
                    createdBy
                    updatedBy
                    ownerEmail
                    createTime
                    updateTime
                    timeoutSeconds
                    failureWorkflow
                    workflowStatusListenerEnabled
                    outputParameters
                    inputParameters
                    schemaVersion
                    restartable
                    readOnly
                }

                fragment workflowTask on WorkflowTask {
                    type
                    name
                    description
                    caseValueParam
                    caseExpression
                    decisionCases
                    inputParameters
                    taskReferenceName
                    subWorkflowParam {
                        name
                        version
                    }
                    dynamicForkTasksInputParamName
                    dynamicForkTasksParam
                    optional
                    sink
                    startDelay
                    asyncComplete
                }
            `,
            variables() {
                return {
                    name: this.name,
                    version: this.version,
                    skip: false,
                };
            },
            update: (data) => data.getWorkflow || {},
        },
    },
};
</script>
